import { FormType } from '../../../form-types';
import { ModafinilFollowupQuestionFieldAnswers } from './questions';

export const modafinilFollowup: FormType<ModafinilFollowupQuestionFieldAnswers> =
  {
    name: 'Modafinil Follow Up',
    questions: [
      'modafinilFollowup_sexAssignedAtBirth',
      {
        key: 'modafinilFollowup_treatmentProgress',
        next: {
          condition: { 'modafinilFollowup_treatmentProgress.not_well': true },
          key: 'modafinilFollowup_treatmentProgressDetails',
          els: 'modafinilFollowup_sideEffects'
        }
      },
      'modafinilFollowup_treatmentProgressDetails',
      {
        key: 'modafinilFollowup_sideEffects',
        next: {
          condition: { 'modafinilFollowup_sideEffects.yes': true },
          key: 'modafinilFollowup_sideEffectsDetails',
          els: 'modafinilFollowup_healthChanges'
        }
      },
      'modafinilFollowup_sideEffectsDetails',
      {
        key: 'modafinilFollowup_healthChanges',
        next: {
          condition: { 'modafinilFollowup_healthChanges.yes': true },
          key: 'modafinilFollowup_healthChangesDetails',
          els: 'modafinilFollowup_bloodPressure'
        }
      },
      'modafinilFollowup_healthChangesDetails',
      {
        key: 'modafinilFollowup_bloodPressure',
        next: {
          switch: [
            {
              condition: {
                'modafinilFollowup_bloodPressure.very_high': true
              },
              key: 'generic_ineligible'
            },
            {
              condition: {
                'modafinilFollowup_bloodPressure.severely_high': true
              },
              key: 'generic_ineligible'
            }
          ],
          els: 'modafinilFollowup_heartRate'
        }
      },
      {
        key: 'modafinilFollowup_heartRate',
        next: {
          condition: { 'modafinilFollowup_heartRate.high': true },
          key: 'generic_ineligible',
          els: 'modafinilFollowup_treatmentPreference'
        }
      },
      'modafinilFollowup_treatmentPreference',
      'modafinilFollowup_additionalQuestions',
      {
        key: 'modafinilFollowup_treatmentConsent',
        next: {
          condition: {
            'modafinilFollowup_treatmentConsent.do_not_continue': true
          },
          key: 'generic_didNotConsent',
          els: 'generic_complete'
        }
      },
      'generic_complete',
      'generic_ineligible',
      'generic_didNotConsent'
    ]
  };

export default modafinilFollowup;
